// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"fbd1f2df","112":"c2473bd5","159":"b4dc3362","295":"d026ff30","342":"954d57b1","403":"731d5d13","429":"4ead936f","511":"39c2f570","653":"22e4c294","759":"ad3312bf","915":"32ce4ee8","939":"758051f6","949":"d09e1e85"}[chunkId] + ".chunk.js";
};